<template>
    <!-- 开关组件 -->
    <el-switch
    v-model="value"
    :active-color="activeColor"
    :inactive-color="inactiveColor"
    :active-text="activeText"
    :inactive-text="inactiveText"
    :disabled="disabled"
    :width="width"
    :active-icon-class="activeIconClass"
    :inactive-icon-class="inactiveIconClass"
    :name="name"
    :validate-event="validate"
    @change="change"
    />
</template>
<script>
export default {
    name:"VelSwitch",
    props:{
        initValue:[Boolean,String,Number],
        activeColor:String,
        inactiveColor:String,
        activeText:String,
        inactiveText:String,
        activeValue:[Boolean,String,Number],
        inactiveValue:[Boolean,String,Number],
        width:Number,
        activeIconClass:String,
        inactiveIconClass:String,
        name:String,
        isValidate:Boolean,
        isDisable:Boolean,
    },
    data() {
        return {
            value: null,
            validate:true,
            disabled:false,
        };
    },
    watch: {
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value = newval
            },
            deep:true,
            immediate:true
        }
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isValidate ? this.validate = false : this.validate
            this.isDisable ? this.disabled = true : this.disabled
        },
        getValue(){
            this.initValue ? this.value = this.initValue :
            this.value = false
        },
        change(val){
            this.$emit('change',val)
        }
    }
}
</script>